// extracted by mini-css-extract-plugin
module.exports = {"pitch":"Pitch_pitch__1KKqH","outlines":"Pitch_outlines__jEzGC","pitchWrapper":"Pitch_pitchWrapper__1ZJ9m","pitchGroupWrapper":"Pitch_pitchGroupWrapper__2XL91"};